"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerFields = void 0;
var TriggerFields;
(function (TriggerFields) {
    let trigger;
    (function (trigger) {
        trigger["DEPLOYMENT_UPDATE"] = "deploymentUpdate";
        trigger["BOT_COMMAND_UPDATE"] = "botCommandUpdate";
        trigger["BRIEF_UPDATE"] = "briefUpdate";
        trigger["CONTRACT_UPDATE"] = "contractUpdate";
        trigger["CREATOR_PAY_PER_EVENT_UPDATE"] = "creatorPayPerEventUpdate";
        trigger["LIVE_STREAM_UPDATE"] = "liveStreamUpdate";
        trigger["OVERLAY_UPDATE"] = "overlayUpdate";
        trigger["PANEL_BANNER_UPDATE"] = "panelBannerUpdate";
        trigger["PAY_PER_EVENT_UPDATE"] = "payPerEventUpdate";
        trigger["PAY_PER_EVENT_BRACKET_UPDATE"] = "payPerEventBracketUpdate";
        trigger["TIK_TOK_CREATIVE_UPDATE"] = "tikTokCreativeUpdate";
        trigger["YOU_TUBE_VIDEO_UPDATE"] = "youTubeVideoUpdate";
        trigger["MARKDOWN_BRIEF_UPDATE"] = "markdownBriefUpdate";
    })(trigger = TriggerFields.trigger || (TriggerFields.trigger = {}));
})(TriggerFields = exports.TriggerFields || (exports.TriggerFields = {}));
